export default {"src":"/uk/_next/static/media/lightGreyInfoIcon.465ca0fd.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};